import { IExposableService } from 'app-core/src/interfaces/exposable-service.inteface';
import { INotificationDisplayDetails } from 'app-core/src/models/notification-display-details.model';
import { TrackEvent } from 'app-core/src/models/tracking-event.model';
import { ABTestParams } from 'app-core/src//services/notification-analytics/models/ab-test-params.model';
import { DelegateProvider } from './delegate-provider.interface';

// -----------------------------------------------------------------------------
export const kNameOfUserActionService = 'UserActionService';

// -----------------------------------------------------------------------------
export interface IUserActionService
  extends IExposableService,
    DelegateProvider<IUserActionServiceDelegate> {
  installApplication(notificationInfo: INotificationDisplayDetails);
  openApplicationInStore(notificationInfo: INotificationDisplayDetails);
  openNotificationSettings(notificationInfo: INotificationDisplayDetails);
  turnOffNotifications(notificationInfo: INotificationDisplayDetails);
  sendTrackingEvent(event: TrackEvent);
  notificationDismissed(
    notificationDismissed: INotificationDisplayDetails,
    visibilityTimeInSeconds: number,
  );
  notificationDismissedWhileDownloading(
    notificationDismissed: INotificationDisplayDetails,
    visibilityTimeInSeconds: number,
  );
  sendErrorTrackingEvent(notificationDismissed: INotificationDisplayDetails);
  gameExcluded(gameId: number);
  applicationExcluded(ExtensionId: string);
  OpenExternalUrl(
    url: string,
    activeNotificationInfo: INotificationDisplayDetails,
  );
  notificationABTest(params: ABTestParams);
  OnDownloadExternalApplication(
    downloadAppId: string,
    activeNotificationInfo: INotificationDisplayDetails,
  );
  OnCancelDownloadExternalApplication(
    activeNotificationInfo: INotificationDisplayDetails,
  );
}

export interface IUserActionServiceDelegate {
  onUserActionDismissed?(activeNotification: INotificationDisplayDetails);
  onGameExcluded?(gameId: any);
  onApplicationExcluded?(extensionId: any);
  onDownloadStarted?(url: string);
  onDownloadError?(url: string);
  onDownloadProgress?(progress: string);
  onFileExecuted?(result: boolean);
  onDownloadCompleted?(url: string);
}
